import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { OnDestroyComponent } from '../../../shared/components/on-destroy/on-destroy.component';
import { AutoUnsubscribe } from '../../../utils/misc/auto-unsubscribe';

@Component({
  selector: 'app-kazaplan-360-view-page',
  templateUrl: './kazaplan-360-view-page.component.html',
  styleUrls: ['./kazaplan-360-view-page.component.scss']
})
@AutoUnsubscribe()
export class Kazaplan360ViewPageComponent extends OnDestroyComponent implements OnInit {
  imageUrl: string;

  constructor(
    private activatedRoute: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params.imageUrl) {
        this.imageUrl = params.imageUrl;
      }
    });
  }
}
